import { render, staticRenderFns } from "./MarriageReportTwo.vue?vue&type=template&id=427fa3a3&"
import script from "./MarriageReportTwo.vue?vue&type=script&lang=js&"
export * from "./MarriageReportTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports